module.exports = __webpack_public_path__ + "img/contexity-logo-boxed.84dca29d.png";